import { Grow, Hidden, Paper, TextField, Grid } from '@material-ui/core';
import DivLoader from 'components/Shared/DivLoader';
import EmptyState from 'components/Shared/EmptyState';
import Snackbar from 'components/Shared/Snackbar';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IOrderBump } from 'interfaces/orderbump';
import React, { Fragment, PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import { orderBumpService } from 'services/orderBumpService';

import RowList from './RowList';

interface IState {
  orderBumps: IOrderBump[];
  filteredOrderBumps: IOrderBump[];
  searchTerm: string;
  isEmpty: boolean;
}

interface IProps {
  handleRegister: (orderBump?: IOrderBump) => void;
  renderDash: () => void;
  classes?: any;
}

@WithStyles(() => ({
  containerPaper: {
    padding: '24px'
  },
  tab: {
    marginTop: '10px'
  },
  fieldSearch: {
    width: '100%',
    '& svg': {
      width: 20,
      height: 30,
      marginRight: 10
    }
  },
  columns: {
    padding: '8px 13px',
    margin: '10px 0',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& p': {
      color: '#8E8E8E',
      margin: 0,
      alignSelf: 'center',
      fontSize: '16px',
      padding: '0 8px',
      letterSpacing: '0.44px',
      lineHeight: '16px'
    }
  }
}))
export default class ListOrderBump extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { orderBumps: null, filteredOrderBumps: null, searchTerm: '', isEmpty: false };
  }

  componentDidMount() {
    this.getOrderBumps();
  }

  getOrderBumps = () => {
    orderBumpService
      .getOrderBumpsProducer()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(orderBumps => {
        this.setState({ orderBumps });
        if (orderBumps.length === 0) {
          this.setState({ isEmpty: true });
        }
      });
  };

  filterOrderBumps = (value: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    this.setState({ searchTerm: value.target.value });
    const { orderBumps, searchTerm } = this.state;

    const filteredOrderBumps = orderBumps.filter(orderBump => {
      const { bump, owner } = orderBump;
      return (
        String(bump.id).includes(searchTerm) ||
        String(owner.id).includes(searchTerm) ||
        owner.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        bump.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });

    this.setState({ filteredOrderBumps });
  };

  powerOrderBump = (orderbump: IOrderBump) => {
    if (!orderbump.bump || !orderbump.owner) {
      Snackbar.error('Este order bump está inválido, não é possível liga-lo.');
      return;
    }

    const updateOrder = (msg: string, ativo: number) =>
      orderBumpService
        .updateOrderBump(orderbump.id, orderbump.ownerId, orderbump.bumpId, orderbump.description, ativo)
        .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
        .subscribe(
          () => {
            this.getOrderBumps();
            Snackbar.show(msg);
          },
          err => {
            Snackbar.error(err.message);
          }
        );

    if (orderbump.ativo === 1) {
      updateOrder('Desligado com sucesso!', 0);
    } else {
      updateOrder('Ligado com sucesso!', 1);
    }
  };

  render() {
    const { classes, handleRegister } = this.props;
    const { orderBumps, searchTerm, filteredOrderBumps, isEmpty } = this.state;
    const list = !!searchTerm && searchTerm.length >= 3 ? filteredOrderBumps : orderBumps;

    const component = !list ? (
      <DivLoader list width="100%" height="66px" />
    ) : (
      list.map((orderBump, index) => (
        <Grow key={orderBump.id} in={true}>
          <RowList
            powerOrderBump={this.powerOrderBump}
            handleRegister={handleRegister}
            key={index}
            orderbump={orderBump}
          />
        </Grow>
      ))
    );

    return (
      <Fragment>
        <Hidden mdUp>No momento, não é possível cadastrar order bumps em aparelhos mobile</Hidden>
        <Hidden smDown>
          <Paper elevation={0}>
            {!!isEmpty ? (
              <EmptyState
                title="Com o order bump no seu checkout você pode vender muito mais"
                subtitle="Oferte novos produtos por um preço promocional, recomendamos
                sempre ofertar um produto de menor valor que o produto principal"
                buttonTitle="Criar novo order bump"
                onClick={handleRegister}
              />
            ) : (
              <div className={classes.containerPaper}>
                {!!list && (
                  <div>
                    <TextField
                      placeholder="Pesquisar…"
                      classes={{ root: classes.fieldSearch }}
                      onChange={this.filterOrderBumps}
                      InputProps={{
                        startAdornment: <SvgIcon name="search" />
                      }}
                    />
                  </div>
                )}
                <Grid className={classes.columns} container>
                  <Grid xs={1} item>
                    <p>Status</p>
                  </Grid>
                  <Grid xs={5} item>
                    <p>Produto</p>
                  </Grid>
                  <Grid xs={5} item>
                    <p>Bump</p>
                  </Grid>
                  <Grid xs={1}></Grid>
                </Grid>
                <div className={classes.tab}>{component}</div>
              </div>
            )}
          </Paper>
        </Hidden>
      </Fragment>
    );
  }
}
